import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as currencyActionCreators from 'core/actions/actions-currency'
import * as transactionActionCreators from 'core/actions/actions-transaction'
import * as uiActionCreators  from 'core/actions/actions-ui'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import TokenMenu from 'components/TokenMenu'
import DepositLiquidityInputs from './components/DepositLiquidityInputs'
import wethToken from 'assets/icons/tokens/weth.png'
import daiToken from 'assets/icons/tokens/dai.png'
import { styles } from './styles.scss'
    
const defaultFirstTokenHTML = (
  <div>
    <img width="20" src={wethToken} />WETH
  </div>
)
const defaultSecondTokenHTML = (
  <div>
    <img width="20" src={daiToken} />DAI
  </div>
)

class DepositView extends Component {
  constructor(props) {
    super(props)

    const { currency } = this.props
    const { currency0, currency1 } = currency

    this.state = { 
      selectedFirstTokenHTML: defaultFirstTokenHTML,
      selectedSecondTokenHTML: defaultSecondTokenHTML,
      currency0: currency0,
      currency1: currency1
    }
  }
  
  onFirstTokenChange= (selectedCurrency, selectedTokenElem) => {
    const { actions } = this.props
    const selectedTokenHTML = selectedTokenElem.innerHTML
    const html = (
      <div dangerouslySetInnerHTML={{ __html: selectedTokenHTML }}>
      </div>
    )

    console.log('---- 1st token: selectedCurrency ----', selectedCurrency)

    if(selectedCurrency) {
      this.setState({ 
        selectedFirstTokenHTML: html,
        currency0: selectedCurrency
      })
    } else {
      this.setState({ 
        selectedFirstTokenHTML: defaultFirstTokenHTML,
        currency0: selectedCurrency
      })
    }

    actions.currency.selectCurrency({ 
      currency0: selectedCurrency, 
      currency1: this.state.currency1
    })
  }

  onSecondTokenChange= (selectedCurrency, selectedTokenElem) => {
    const { actions, currency } = this.props
    const { routeUpdated } = currency
    const selectedTokenHTML = selectedTokenElem.innerHTML
    const html = (
      <div dangerouslySetInnerHTML={{ __html: selectedTokenHTML }}>
      </div>
    )

    console.log('---- 2nd token: selectedCurrency ----', selectedCurrency)

    if(selectedCurrency) {
      this.setState({ 
        selectedSecondTokenHTML: html,
        currency1: selectedCurrency 
      })
    } else {
      this.setState({ 
        selectedSecondTokenHTML: defaultSecondTokenHTML,
        currency1: null 
      })
    }

    actions.currency.selectCurrency({ 
      currency0: this.state.currency0,
      currency1: selectedCurrency
    })
    
    actions.currency.updateTradeRoute(!routeUpdated )
  }

  submitForm= (event) => {
    const { actions } = this.props
    actions.transaction.addLiquidity()
    event.preventDefault()
  }

  connectWallet = () =>{
    const { actions } = this.props
    actions.ui.openRightDrawer()
  }
  
  getDepositButton= () => {
    const { provider } = this.props
    const { metaMaskAccount } = provider
    let depositBtnElem

    if(metaMaskAccount) {
      depositBtnElem = (
        <Button
          id="deposit-liquidity-button"
          color="primary"
          variant="contained"
          type="submit"
        >
          Deposit
        </Button>
      )
    } else {
      depositBtnElem = (
        <Button
          id="deposit-liquidity-button"
          color="primary"
          variant="contained"
          onClick={this.connectWallet}
        >
          Connect Wallet
        </Button>
      )
    }

    return depositBtnElem
  }

  render() {
    const { 
      selectedFirstTokenHTML,
      selectedSecondTokenHTML
    } = this.state

    return (
      <div className={styles}>
        <div className="container">
          <div className="section">
            <div id="deposit-liquidity-form-container" className="box">
              <h3><strong> <FormattedMessage id="global.action.depositLiquidity" /></strong></h3>
              <h4><strong><FormattedMessage id="global.action.selectPair" /></strong></h4>
              <p><FormattedMessage id="global.action.selectPairInstructions" /></p>
              <form id="deposit-liquidity-form" onSubmit={this.submitForm}>
                <div id="deposit-liquidity-token-menus" className="section">
                  <TokenMenu onClose={this.onFirstTokenChange}>
                    <div className="menu-item">
                      {selectedFirstTokenHTML}
                    </div>
                  </TokenMenu>
                  <TokenMenu onClose={this.onSecondTokenChange}>
                    <div className="menu-item">
                      {selectedSecondTokenHTML}
                    </div>
                  </TokenMenu>
                </div>
                <br />
                <br />
                <div id="deposit-liquidity-inputs" className="section">
                  <h4><strong>Deposit tokens</strong></h4>
                  <p>Specify the token amounts for your liquidity contribution.</p>
                  <DepositLiquidityInputs />
                </div>
                <div className="section">
                  {this.getDepositButton()}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    currency: state.currency,
    provider: state.provider
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      currency: bindActionCreators(currencyActionCreators, dispatch),
      transaction: bindActionCreators(transactionActionCreators, dispatch),
      ui: bindActionCreators(uiActionCreators, dispatch)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DepositView)